import styled from '@emotion/styled'
import { useQuery } from '@tanstack/react-query'
import { useContext, useState } from 'react'
import { useTranslation } from 'react-i18next'
import Breakpoint from '../../../Breakpoint'
import CoachMemberCard from '../../../components/coach/CoachMemberCard'
import Loader from '../../../components/global/Loader'
import SearchInput from '../../../components/global/SearchInput'
import Title from '../../../components/global/Title'
import { StyledButtonLink } from '../../../components/table/Td'
import UserContext from '../../../context/UserContext'
import { useLangSelected } from '../../../hooks/useLangSelected'
import { apiClient } from '../../../services/apiClient'
import { CoachModel } from '../../../types/coach.type'

const CoachMyMembers = () => {
    const user = useContext(UserContext)
    const { t } = useTranslation('translation')

    const lng = useLangSelected()

    const [searchTerm, setSearchTerm] = useState('')

    const { data: coach } = useQuery({
        queryKey: ['coach-my-members'],
        queryFn: () =>
            apiClient
                .get<CoachModel>(`/coachs/${user.coachData.id}`, { params: { role: 'ROLE_COACH' } })
                .then((res) => res.data),
    })

    if (!user.coachData || !coach) return <Loader />

    return (
        <div>
            <MembersTitleWrapper>
                <div>
                    <Title>{t('coach.my-members')}</Title>
                    <SearchInput
                        value={searchTerm}
                        onChange={(e) => setSearchTerm(e.target.value)}
                        placeholder="Rechercher un membre..."
                    />
                </div>
                <StyledButtonLink
                    to={`/${lng}/bva-coach/mes-membres/selectionner-des-membres`}
                    className="btn btn-primary"
                >
                    {t('coach.select-members')}
                </StyledButtonLink>
            </MembersTitleWrapper>
            <SkillsWrapper>
                {coach.users
                    .filter((user: any) =>
                        `${user.firstName} ${user.lastName}`.toLowerCase().includes(searchTerm.toLowerCase()),
                    )
                    .map((user: any) => <CoachMemberCard key={'CoachMemberCard-' + user.id} user={user} />) ?? (
                    <p>Aucun membre trouvé</p>
                )}
            </SkillsWrapper>
        </div>
    )
}

export const SkillsWrapper = styled.div`
    display: grid;
    grid: auto-flow / 1fr 1fr 1fr 1fr;
    gap: 16px;
    margin-bottom: 16px;

    @media (max-width: ${Breakpoint.TABLET_L}) {
        grid: auto-flow / 1fr;
        margin-top: 16px;
    }
`

const MembersTitleWrapper = styled.div`
    display: flex;
    justify-content: space-between;
    align-items: flex-start;
    margin-bottom: 20px;
    flex-wrap: wrap;
    gap: 20px;

    & > div {
        flex: 1;
        width: 100%;
    }

    @media (max-width: ${Breakpoint.TABLET_L}) {
        flex-direction: column;
        gap: 0;
    }
`

const TextContainer = styled.div`
    display: flex;
    flex-direction: column;
    width: 100%;
    padding: 24px;
    border-radius: 6px;
    background-color: white;
    margin-bottom: 16px;
`

export default CoachMyMembers
